import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    pageCreateNft:{
        padding: "20px 0"
    }

});

export { useStyles };